/**
 * Used as the value for a null or missing category group name throughout drilldown + reductions.
 * This name is never displayed to the user, but is used as a special value to indicate _lack of_
 * a value. We always use `getNoneGroupNameLabel` to make a human readable version.
 *
 * The only place a user will see this value is in the URL, so we keep it short and unique.
 */
export const NONE_GROUP_NAME = 'NOT_SPECIFIED';
